import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IconDefinition, faAddressBook } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';

import {
   DirectoryBrowserEditedSetConfirmationInProgress,
   DirectoryBrowserEditedUpdateOriginEntry,
   DirectoryBrowserUpdateEditedEntry,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.actions';
import {
   DirectoryEditingBehaviourState,
   DirectoryEntryEditInfo,
} from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';

@Component({
   selector: 'samweb-directory-editing-confirmation-dialog',
   templateUrl: './directory-editing-confirmation-dialog.component.html',
   styleUrls: ['./directory-editing-confirmation-dialog.component.scss'],
})
export class DirectoryEditingConfirmationDialogComponent implements OnInit, AfterViewInit {
   public isConfirmationInProgress$: Observable<boolean>;
   @Input()
   public id: number;

   public entriesForComparison$: Observable<DirectoryColumn[]>;

   public directoryEditInfo$: Observable<DirectoryEntryEditInfo>;

   public titleBarIcon: IconDefinition = faAddressBook;

   public sourceBrickInstanceId: string;

   public width = 450;

   @ViewChild('header')
   public header: HTMLElement;
   @ViewChild('oldValue')
   public oldValue: HTMLElement;
   @ViewChild('separatorIcon')
   public separatorIcon: HTMLElement;
   @ViewChild('newValue')
   public newValue: HTMLElement;

   constructor(public store: Store) {}

   ngAfterViewInit(): void {
      this.width = this.header?.offsetWidth + this.oldValue?.offsetWidth + this.separatorIcon?.offsetWidth + this.newValue?.offsetWidth;
   }

   ngOnInit(): void {
      this.isConfirmationInProgress$ = this.store
         .select(DirectoryEditingBehaviourState.isConfirmationInProgress)
         .pipe(map((isInProgess) => isInProgess(this.id)));

      this.directoryEditInfo$ = this.store.select(DirectoryEditingBehaviourState.getEditedDirectoryInfoById).pipe(map((getEntry) => getEntry(this.id)));

      this.entriesForComparison$ = this.store.select(DirectoryEditingBehaviourState.getEntriesForComparison).pipe(map((getEntries) => getEntries(this.id)));
   }

   confirm() {
      this.store.dispatch(new DirectoryBrowserEditedUpdateOriginEntry(this.id));
      this.store.dispatch(new DirectoryBrowserUpdateEditedEntry(this.id));
      this.store.dispatch(new DirectoryBrowserEditedSetConfirmationInProgress(this.id, false));
   }

   cancel() {
      this.store.dispatch(new DirectoryBrowserEditedSetConfirmationInProgress(this.id, false));
   }
}
